import './spinner.scss';

const Spinner = () => {
  return (
      <span className="loader"></span>
  );
};

export default Spinner;
